import React from 'react';
import './footer.css';
import logo from '../../assets/GOODNESS ONONOGBU LOGO.png';
import { IoLogoLinkedin } from "react-icons/io";
import { BiLogoGmail } from "react-icons/bi";


const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <footer className="footer" role="contentinfo" aria-label="Site footer">
      <div className="footer-card">
        <div className="footer-container">
          {/* Logo */}
          <div className="footer-logo">
            <img src={logo} alt="GOODNESS ONONOGBU LOGO" />
          </div>

          {/* Contact Information */}
          <div className="footer-contact">
            <h4>Contact Information</h4>
            <ul>
                    <li><a href="mailto:ononogbugoodness@gmail.com" target='_blank' rel='noopener noreferrer' aria-label="Send email"><BiLogoGmail aria-hidden={true} /> EMAIL</a></li>
                    <li><a href="https://www.linkedin.com/in/goodness-ononogbu/" target='_blank' rel='noopener noreferrer' aria-label="LinkedIn profile"><IoLogoLinkedin aria-hidden={true} /> LINKEDIN</a></li>
                </ul>
            <p>England, United Kingdom</p>
          </div>

          {/* Navigation Links */}
          <div className="footer-nav">
            <ul>
              <li><a href="/">Home</a></li>
              <li><a href="/about">About</a></li>
              <li><a href="/blog">Blog</a></li>
              <li><a href="/projects">Projects</a></li>
              <li><a href="/contact">Contact</a></li>
            </ul>
          </div>
        </div>
        <div className="footer-date">
          <p><b>&copy; {currentYear} GOODNESS ONONOGBU. All rights reserved.</b></p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
